module.exports = __webpack_public_path__ + "static/img/logo.495817c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 257
// module chunks = 45